import React, { useEffect, useState } from "react";

const Footer = ({ classicHeader, darkTheme, handleNavClick }) => {
  const STORAGE_KEY = "elle_cookie_consent";
  const [showCookieBanner, setShowCookieBanner] = useState(false);

  useEffect(() => {
    try {
      const existing = window.localStorage.getItem(STORAGE_KEY);
      setShowCookieBanner(!existing);
    } catch (e) {
      setShowCookieBanner(true);
    }
  }, []);

  const setConsent = (value) => {
    try {
      window.localStorage.setItem(STORAGE_KEY, value);
    } catch (e) {
      // ignore storage errors, still hide banner for this session
    }
    setShowCookieBanner(false);
  };

  return (
    <>
      <footer
        id="footer"
        className={"section " + (darkTheme ? "footer-dark bg-dark-1" : "")}
      >
        <div className={"container " + (classicHeader ? "" : "px-lg-5")}>
          <div className="row">
            <div className="col-lg-6 text-center text-lg-start">
              <p className="mb-3 mb-lg-0">
                Copyright © 2026{" "}
                <a
                  href="#home"
                  className="fw-500"
                  onClick={(e) => {
                    e.preventDefault();
                    handleNavClick("home");
                  }}
                >
                  Elle Innovations Inc
                </a>
                . All Rights Reserved. Patent Pending
              </p>
            </div>
            <div className="col-lg-6">
              <ul className="nav nav-separator justify-content-center justify-content-lg-end">
                <li className="nav-item">
                  <a
                    className="nav-link"
                    data-bs-toggle="modal"
                    data-bs-target="#terms-policy"
                    href="#terms-policy"
                  >
                    Terms &amp; Policy
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    className="nav-link"
                    data-bs-toggle="modal"
                    data-bs-target="#policy"
                    href="#policy"
                  >
                    Technology Policy
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    className="nav-link"
                    data-bs-toggle="modal"
                    data-bs-target="#disclaimer"
                    href="#disclaimer"
                  >
                    Disclaimer
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </footer>

      {showCookieBanner && (
        <div
          className={
            "position-fixed bottom-0 start-0 end-0 shadow-lg " +
            (darkTheme ? "bg-dark text-white" : "bg-white text-dark")
          }
          style={{ zIndex: 1080, borderTop: "1px solid rgba(0,0,0,0.1)" }}
        >
          <div className="container py-3 d-flex flex-column flex-lg-row align-items-start align-items-lg-center justify-content-between gap-3">
            <div className="me-lg-4">
              <div className="fw-600">We use cookies</div>
              <div className="small">
                We use cookies and similar technologies to enhance your
                experience, analyze traffic, and personalize content. You can
                accept all cookies or reject non-essential cookies. You can
                change your preferences at any time.
              </div>
            </div>
            <div className="d-flex flex-column flex-sm-row gap-2">
              <button
                type="button"
                className="btn btn-outline-secondary"
                data-bs-toggle="modal"
                data-bs-target="#cookie-details"
              >
                Cookie details
              </button>
              <button
                type="button"
                className="btn btn-secondary"
                onClick={() => setConsent("rejected")}
              >
                Reject non-essential
              </button>
              <button
                type="button"
                className="btn btn-primary"
                onClick={() => setConsent("accepted")}
              >
                Accept all
              </button>
            </div>
          </div>
        </div>
      )}

      <div
        className="modal fade"
        id="cookie-details"
        tabIndex="-1"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg modal-dialog-centered">
          <div className={"modal-content " + (darkTheme ? "bg-dark text-white" : "")}>
            <div className="modal-header">
              <h5 className="modal-title">Cookie Policy</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <p>
                We use cookies and similar technologies to keep the site secure,
                remember your preferences, measure performance, and improve the
                experience. Some cookies are essential for the site to function.
                Others help us understand usage and personalize content.
              </p>
              <p className="mb-0">
                You can accept all cookies or reject non-essential cookies. Your
                choice is stored in your browser and can be changed at any time.
              </p>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-outline-secondary"
                data-bs-dismiss="modal"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Footer;
